import React from 'react'
import PropTypes from 'prop-types'

const PUBLIC_URL = 'https://mytabworks.github.io'

const MetaTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.string,
    type: PropTypes.string,
    url: PropTypes.string,
}

export const Meta = ({ title, description, image, type = "website", url = window.location.pathname }) => (
    <>
        <title>{title}</title>
        <meta name="title" content={title} />
        <meta name="description" content={description} />
        <meta property="og:type" content={type} />
        <meta property="og:url" content={PUBLIC_URL + url} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={PUBLIC_URL + image} />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content={PUBLIC_URL + url} />
        <meta property="twitter:title" content={title} />
        <meta property="twitter:description" content={description} />
        <meta property="twitter:image" content={PUBLIC_URL + image} />
    </>
)

Meta.propTypes = MetaTypes